import linkifyHtml from 'linkify-html';
import Link from 'next/link';

import lineBreaker from '../../utils/lineBreaker';
import Expander from '../Expander';

const AboutDetails = ({ slug, name, description }) => (
  <div className="about-container">
    <Expander
      summary={
        <span>
          About{' '}
          <Link
            href="/discover/partner/[permalink]"
            as={`/discover/partner/${slug} `}
            data-testid="merchant-name"
          >
            {name}
          </Link>
        </span>
      }
      details={
        <div
          dangerouslySetInnerHTML={{
            __html: lineBreaker(linkifyHtml(description)),
          }}
        />
      }
    />
  </div>
);

export default AboutDetails;
